/*eslint-disable no-restricted-globals */
import { useRef, useEffect, useState, Fragment } from 'react';
import { t } from 'i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import backBtn from '../../../img/pricecompare/back-btn.svg';
import './ResultPage.scss';
import FinalResultTile from '../components/FinalResultTile/FinalResultTile';
import LongTimeError from '../../common/long-time-error/LongTimeError';
import CompareResultsCard from '../skeleton/CompareResultsCard';
import { formatDoctorName, getDataByClaimID } from '../../../utils/common';
import { apiDataGenerationForCompare } from 'src/Admin/utils/common';

import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import DataNotFound from '../../common/dataNotFound/DataNotFound';

const ResultPage = () => {
  const { id } = useParams();
  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams.filters,
  );

  const { Provider } = allFilters;
  let { selectedCheckedRowData } = useSelector(
    (state) => state?.priceCompareAdmin,
  );
  const {
    searchParamsForUI,
    searchProviderParams,
    providerType,
    selectedCheckedItems,
  } = useSelector((state) => state?.priceCompareAdmin);
  const {
    Display_Network_For_PriceComparison_Admin,
    Value_Network_For_PriceComparison_Admin,
  } = useSelector((state) => state?.app?.appConfigs?.Network_Setting);
  const CoveredCostComparePriceArray = [];
  const [requestID, setRequestID] = useState('');
  const [recentSearchBack, setRecentSearchBack] = useState(false);
  const noResultsFound = false;
  const [noResult, setNoResult] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const pageInfo = useRef(null);
  const [isLoading, SetIsLoading] = useState(false);
  const [compareData, setCompareData] = useState([]);
  const [disclaimer, setDisclaimer] = useState('');
  const [paramsData, setParamsData] = useState(searchParamsForUI);
  const searchTerm = `Request ID ${requestID} / ${paramsData?.typesOfSpecialtyData?.label}`;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  //if (searchParamsForUI) {
  //}

  const getPostRequestData = async () => {
    const selectedUser = searchParamsForUI?.procedureForData?.value;
    const loggedInMemberType = 'Member';
    const API_PAYLOAD = {
      pricecompareClaim: {
        searchParams: {
          providerType: providerType,
          procedureForData: searchParamsForUI?.procedureForData,
          helthProcedureData: searchParamsForUI?.helthProcedureData,
          locationData: searchParamsForUI?.locationData,
          providerByData: searchParamsForUI?.providerByData,
          networksData: searchParamsForUI?.networksData,
          typesOfSpecialtyData: searchParamsForUI?.typesOfSpecialtyData,
          maximumradius: searchProviderParams?.filters?.maximumradius,
          Gender: searchProviderParams?.filters?.Gender,
          AcceptingNewPatients: searchProviderParams?.AcceptingNewPatients,
          spokenlanguages: searchProviderParams?.filters?.spokenlanguages,
          specialities: searchProviderParams?.filters?.specialities,
          BilledAmt: searchParamsForUI?.billedamount,
        },
        comparison: {
          selectedCheckedItems: selectedCheckedItems,
          selectedCheckedRowData: selectedCheckedRowData,
        },
        apiData: apiDataGenerationForCompare({
          selectedCheckedItems,
          searchParamsForUI,
        }),
      },
    };

    const response = await axiosInstance.post(
      APIEndpoints.getComparedRequestId() + '/storeasrecent/true',
      API_PAYLOAD,
    );
    const postAddUserDataResp = response.data;
    const DATA = [];
    if (postAddUserDataResp?.Response?.PriceCompareClaimDTO?.length === 0) {
      setNoResult(true);
    }
    postAddUserDataResp.Response.PriceCompareClaimDTO.map((apiItem) => {
      //We will/should filter based upon Provider ID , oncewe will start getting ID in API response
      const currentItem = selectedCheckedRowData?.filter(
        (item) =>
          Number(item?.ConnectorId) === Number(apiItem?.ServiceProvider),
      )[0];
      setRequestID(apiItem?.RequestId);
      setDisclaimer(apiItem?.Disclaimer);

      if (Provider === 'doctor') {
        DATA.push({
          Gender: currentItem?.Gender,

          ClaimNumber: apiItem?.ClaimNumber,
          Disclaimer: apiItem?.Disclaimer,
          ProviderName: formatDoctorName(
            currentItem?.DoctorTitle,

            currentItem?.LastName,

            currentItem?.FirstName,

            currentItem?.MiddleName,

            currentItem?.Suffix,
          ),

          YearInPractice: currentItem?.Experiance,

          Specialty: currentItem?.Specialties,

          Distance: currentItem?.Address?.Distance,
          Provider: 'doctor',

          InNetwork: currentItem?.InNetwork, //InNetwork/OutOfNetwork

          ClaimData: {},

          Address: currentItem?.Address,

          SpokenLanguages: currentItem?.SpokenLanguages,

          DoctorNetworks: currentItem?.DoctorNetworks,

          PhysicianID: currentItem?.PhysicianID,
        });
      }

      if (Provider === 'facility') {
        DATA.push({
          ClaimNumber: apiItem?.ClaimNumber,
          Disclaimer: apiItem?.Disclaimer,
          ProviderName: currentItem?.FacilityName,

          Specialty: currentItem?.FacilitySpeciality,

          Distance: currentItem?.Distance,

          InNetwork: currentItem?.InNetwork, //InNetwork/OutOfNetwork

          ClaimData: {},
          Provider: 'facility',

          Address: {
            AddressLine1: currentItem?.Address1,

            AddressLine2: currentItem?.Address2,

            AddressLine3: currentItem?.Address3,

            City: currentItem?.City,

            County: currentItem?.County,

            State: currentItem?.StateProv,

            PostalCode: currentItem?.PostalCode,

            Coordinateds: currentItem?.Coordinateds,
          },

          DoctorNetworks: currentItem?.DoctorNetworks,

          PhysicianID: currentItem?.FacilityID,
        });
      }
      return;
    });

    if (DATA && DATA.length > 0) {
      const promises = DATA.map(async (providerItem) => {
        const DataItem = await axiosInstance.get(
          APIEndpoints.getCompareClaimDetails() + providerItem?.ClaimNumber,
        );
        return DataItem;
      });

      try {
        const results = await Promise.all(
          promises.map((p) => p.catch((e) => e)),
        );
        const validResults = results.filter(
          (result) => !(result instanceof Error),
        );
        const listClaimsData = getDataByClaimID(validResults);
        DATA.map((provider) => {
          if (
            provider &&
            provider.ClaimNumber &&
            listClaimsData &&
            listClaimsData.length > 0
          ) {
            const arrClaims = listClaimsData.filter(
              (f) => f.claimId === provider.ClaimNumber,
            );
            provider.ClaimData = arrClaims[0].data;
          }
          return;
        });
        console.log(DATA);
      } catch (error) {
        console.log('Claims API fails');
      }
    }

    setCompareData([...DATA]);
    SetIsLoading(false);
  };

  const loadRequest = async () => {
    const URL = APIEndpoints.getPriceCompareDetailsById() + id;
    const response = await axiosInstance.get(URL);
    const postAddUserDataResp = response?.data;

    const requestData = postAddUserDataResp?.Response?.PriceCompareDTO;
    const DATA = requestData?.responseObj?.PriceCompareResponse;
    setParamsData(requestData?.requestObj?.searchParams);
    selectedCheckedRowData =
      requestData?.requestObj?.comparison?.selectedCheckedRowData;
    if (DATA && DATA.length > 0) {
      const promises = DATA.map(async (providerItem) => {
        const DataItem = await axiosInstance.get(
          APIEndpoints.getCompareClaimDetails() + providerItem?.ClaimNumber,
        );
        return DataItem;
      });

      try {
        const results = await Promise.all(
          promises.map((p) => p.catch((e) => e)),
        );
        const validResults = results.filter(
          (result) => !(result instanceof Error),
        );
        const listClaimsData = getDataByClaimID(validResults);
        if (requestData?.requestObj?.searchParams?.providerType === 'doctor') {
          DATA.map((provider) => {
            if (
              provider &&
              provider.ClaimNumber &&
              listClaimsData &&
              listClaimsData.length > 0
            ) {
              const arrClaims = listClaimsData.filter(
                (f) => f.claimId === provider.ClaimNumber,
              );

              provider.ClaimData = arrClaims[0].data;

              const currentItem = selectedCheckedRowData?.filter(
                (item) =>
                  Number(item?.ConnectorId) ===
                  Number(provider?.ServiceProvider),
              )[0];

              provider.Gender = currentItem?.Gender;

              setRequestID(provider?.RequestId);

              provider.ProviderName = formatDoctorName(
                currentItem?.DoctorTitle,

                currentItem?.LastName,

                currentItem?.FirstName,

                currentItem?.MiddleName,

                currentItem?.Suffix,
              );
              provider.Provider = 'doctor';
              provider.YearInPractice = currentItem?.Experiance;

              provider.Specialty = currentItem?.Specialties;

              provider.Distance = currentItem?.Address?.Distance;

              provider.InNetwork = currentItem?.InNetwork;

              provider.Address = currentItem?.Address;

              provider.SpokenLanguages = currentItem?.SpokenLanguages;

              provider.DoctorNetworks = currentItem?.DoctorNetworks;

              provider.PhysicianID = currentItem?.PhysicianID;
            }

            return;
          });
        }

        if (
          requestData?.requestObj?.searchParams?.providerType === 'facility'
        ) {
          DATA.map((provider) => {
            if (
              provider &&
              provider.ClaimNumber &&
              listClaimsData &&
              listClaimsData.length > 0
            ) {
              const arrClaims = listClaimsData.filter(
                (f) => f.claimId === provider.ClaimNumber,
              );

              provider.ClaimData = arrClaims[0].data;

              const currentItem = selectedCheckedRowData?.filter(
                (item) =>
                  Number(item?.ConnectorId) ===
                  Number(provider?.ServiceProvider),
              )[0];

              setRequestID(provider?.RequestId);

              provider.ProviderName = currentItem?.FacilityName;

              //provider.YearInPractice = currentItem?.Experiance;

              provider.Specialty = currentItem?.FacilitySpeciality;

              provider.Distance = currentItem?.Distance;

              provider.InNetwork = currentItem?.InNetwork;
              provider.Provider = 'facility';

              (provider.Address = {
                AddressLine1: currentItem?.Address1,

                AddressLine2: currentItem?.Address2,

                AddressLine3: currentItem?.Address3,

                City: currentItem?.City,

                County: currentItem?.County,

                State: currentItem?.StateProv,

                PostalCode: currentItem?.PostalCode,

                Coordinateds: currentItem?.Coordinateds,
              }),
                //provider.SpokenLanguages = currentItem?.SpokenLanguages;

                (provider.DoctorNetworks = currentItem?.DoctorNetworks);

              provider.PhysicianID = currentItem?.FacilityID;
            }

            return;
          });
        }
        console.log(DATA);
        setRecentSearchBack(true);
      } catch (error) {
        console.log('Claims API fails');
      }
    } else {
      setNoResult(true);
    }
    setCompareData([...DATA]);
    SetIsLoading(false);
  };

  useEffect(() => {
    if (location.state?.from === 'search') {
      SetIsLoading(true);
      (async () => {
        try {
          await getPostRequestData();
        } catch (error) {
          console.log(error);
          SetIsLoading(false);
        }
      })();
    }
    if (id) {
      SetIsLoading(true);
      (async () => {
        try {
          await loadRequest();
        } catch (error) {
          console.log(error);
          SetIsLoading(false);
        }
      })();
    }
  }, [location]);

  const linkHandler = () => {
    navigate('/admin/price-compare');
  };
  const goBack = () => {
    recentSearchBack
      ? location.state.viewAllLinkVisible
        ? navigate('/admin/price-compare')
        : navigate('/admin/price-compare/all-service-request')
      : navigate('/admin/price-compare/search-results', {
          state: {
            procedureForData: paramsData?.procedureForData,
            helthProcedureData: paramsData?.helthProcedureData,
            locationData: paramsData?.locationData,
            providerByData: paramsData?.providerByData,
            typesOfSpecialtyData: paramsData?.typesOfSpecialtyData,
            billedamount:
              paramsData?.BilledAmt || searchParamsForUI?.billedamount,
            CoveredCostComparePriceArray: CoveredCostComparePriceArray,
          },
        });
  };

  return (
    <div className="price-compare-result-page-admin container-fluid">
      <div>
        <span
          className="sr-only"
          role="heading"
          aria-level={1}
          tabIndex={0}
          ref={pageInfo}
        >
          {t('member.price_comparison.accessibility_page_info')}
        </span>
        <div className="header-container">
          <div className="d-flex align-items-center">
            <span>
              <img
                className="back-btn-to-serach-page"
                src={backBtn}
                role="button"
                alt="Click to Go Back"
                onClick={() => goBack()}
              />
            </span>
            <h1 className="content-header m-0" aria-hidden={true}>
              {t('member.price_comparison.heading_text_compare')}{' '}
              <span className="content-header-bold">
                {t('member.price_comparison.heading_text_price')}
              </span>
            </h1>
          </div>
          <div className="modify-btn-container my-auto">
            <GenericButton
              className="modify-filter-btn"
              variant="secondary"
              onClick={() => {
                navigate('/admin/price-compare', {
                  state: { fromFinalResultPage: true },
                });
              }}
              ariaLabel={t(
                'member.price_comparison.another_search_btn_ariaLabel',
              )}
            >
              {t('member.price_comparison.another_search_btn_label')}
            </GenericButton>
          </div>
        </div>
        <div className="id-disclaimer-wraper">
          <div className="request-id-container">
            {t('member.price_comparison.request_id_label')} {requestID}
          </div>
          <div className="disclaimer-container">
            {t('member.price_comparison.disclaimer')}
          </div>
        </div>
        <div className="read-only-data-container">
          <div>
            <div>
              <div className="main-wrapper d-flex justify-content-between mt-3">
                <div className="top">
                  <div className="top-container">
                    <div>
                      <div className="service-provider">
                        <div className="text-container">
                          {t(
                            'member.price_comparison.procedure_container.container_text',
                          )}
                        </div>
                        <div className="flex-container">
                          <div className="search-result-data">
                            <span className="search-result-data-heading">
                              {t(
                                'member.price_comparison.procedure_container.service_for_label',
                              )}
                            </span>
                            {paramsData?.procedureForData?.label}
                            <span className="pipe">&nbsp;|&nbsp;</span>
                          </div>

                          <div className="search-result-data ">
                            <span className="search-result-data-heading">
                              {t(
                                'member.price_comparison.procedure_container.health_procedure_label',
                              )}
                            </span>
                            {paramsData?.helthProcedureData?.label}
                          </div>
                          {paramsData?.BilledAmt &&
                          paramsData?.BilledAmt !== '0.00' ? (
                            <span className="pipe">&nbsp;|&nbsp;</span>
                          ) : (
                            searchParamsForUI?.billedamount &&
                            searchParamsForUI?.billedamount !== '0.00' && (
                              <span className="pipe">&nbsp;|&nbsp;</span>
                            )
                          )}
                          {paramsData?.BilledAmt &&
                          paramsData?.BilledAmt !== '0.00' ? (
                            <div className="search-result-data">
                              <span className="search-result-data-heading mt-4">
                                {t(
                                  'member.price_comparison.procedure_container.billed_amount',
                                )}{' '}
                              </span>
                              {paramsData?.BilledAmt}
                            </div>
                          ) : (
                            searchParamsForUI?.billedamount &&
                            searchParamsForUI?.billedamount !== '0.00' && (
                              <div className="search-result-data">
                                <span className="search-result-data-heading mt-4">
                                  {t(
                                    'member.price_comparison.procedure_container.billed_amount',
                                  )}{' '}
                                </span>
                                {`$${searchParamsForUI?.billedamount}`}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                      <div className="service-provider">
                        <div className="text-container">
                          {t(
                            'member.price_comparison.provider_container.container_text',
                          )}
                        </div>
                        <div className="flex-container">
                          <div className="search-result-data">
                            <span className="search-result-data-heading">
                              {t(
                                'member.price_comparison.provider_container.location_label',
                              )}
                            </span>
                            {paramsData?.locationData}
                          </div>

                          <div className="search-result-data">
                            <span className="pipe">&nbsp;|&nbsp;</span>
                            <span className="search-result-data-heading">
                              {paramsData?.networksData?.isTier
                                ? t(
                                    'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                  ) + ' : '
                                : Display_Network_For_PriceComparison_Admin &&
                                  Value_Network_For_PriceComparison_Admin ===
                                    'tier'
                                ? t(
                                    'member.price_comparison.provider_container.networks_dropdown_labelTier',
                                  ) + ' : '
                                : t(
                                    'member.price_comparison.provider_container.networks_dropdown_label',
                                  ) + ' : '}
                            </span>
                            {paramsData?.networksData?.label ||
                              'All Plan Networks'}
                          </div>

                          {paramsData?.typesOfSpecialtyData?.label && (
                            <div className="search-result-data">
                              <span className="pipe">&nbsp;|&nbsp;</span>
                              <span className="search-result-data-heading">
                                {paramsData?.providerByData === 'doctor-name'
                                  ? t(
                                      'member.price_comparison.provider_container.by_doctor_name',
                                    )
                                  : paramsData?.providerByData === 'doctor-type'
                                  ? t(
                                      'member.price_comparison.provider_container.by_doctor_specialty',
                                    )
                                  : paramsData?.providerByData ===
                                    'facility-type'
                                  ? ' Facility Type'
                                  : ' Facility Name or Tax ID'}{' '}
                                :{' '}
                              </span>
                              {paramsData?.typesOfSpecialtyData?.label}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="provider-details-tiles-admin-container">
          {!isLoading && (
            <>
              {noResult ? (
                <DataNotFound searchText={searchTerm} />
              ) : (
                compareData?.map((data, index) => {
                  return (
                    <FinalResultTile
                      data={data}
                      paramsData={paramsData}
                      key={index}
                    />
                  );
                })
              )}
            </>
          )}

          {isLoading && (
            <div className="mt-5">
              {[0, 1, 2].map((ele, i) => {
                return (
                  <Fragment key={i}>
                    <CompareResultsCard />
                  </Fragment>
                );
              })}
            </div>
          )}

          {noResultsFound && (
            <LongTimeError searchText={searchTerm} linkHandler={linkHandler} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultPage;
